<template>    
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <div class="row">
            <FormInput class="col-12" label="Nombre" name="Nombre" rules="required" v-model="data.name" />
            <FormInput class="col-12" label="Descripción" name="Descripción" v-model="data.description"/>
            <b-col cols="12">
                <b-button type="submit">
                    Continuar
                </b-button>
            </b-col>            
        </div>
    </ValidationObserver>
</template>

<script>
    export default {
        name: 'FormGrupo',
        props: {
            data: {
                type: Object,
                default: () => { return {}; },
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.$emit('terminado');
                }
            }
        }

    }
</script>
